<template>
    <b-card no-body>
            <a target="_blank" @click.stop="openPdfPreview(isClickable)">
                <b-img-lazy v-if="!hasError" fluid-grow 
                            thumbnail 
                            blank-width="100" 
                            blank-height="100"
                            :blank-src="thumbnailPreview" 
                            :src="preview()"
                            class="thumbnail-wrapper" 
                            :class="{'default-cursor': !isClickable}">
                </b-img-lazy>
            </a>
            <b-alert v-if="hasError" show variant="warning" class="mb-0 p-2">
                <b-media no-body>
                    <icon slot="aside" name="info-circle" scale="1.5" class="mr-3"></icon>
                    <b-media-body vertical-align="center">
                        <small class="m-0">{{ $t('general.noPreview') }}</small>
                    </b-media-body>
                </b-media>
            </b-alert>
    </b-card>
</template>

<script>
import imgPlaceholder from '../../assets/thumbload.gif';

export default {
    props: {
        isClickable: {
            type: Boolean,
            default: true
        },
        isShare: Boolean,
        documentId: String
    },
    data() {
        return {
            hasError: false,
            thumbnailPreview: imgPlaceholder
        }
    },
    computed: {
        baseUrl() {
            return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
        },
        filePreviewRoute() {
            return {
                name: 'project-files',
                params: { 
                    projectId: this.$route.params.projectId, 
                    fileId: this.documentId 
                },
                query: {
                    displayFileId: this.documentId
                }
            }
        }
    },
    mounted() {
        let self = this;
        this.$el.querySelector('img').onerror = () => {
            self.hasError = true;
            if(!this.isShare) {
                this.$store.dispatch('userData/loadUserData');
            }
        }
    },
    methods: {
        preview() {
            if(this.isShare) {
                return this.baseUrl + '/colab/epr/public/share/' + this.$route.params.shareToken + '/preview?size=1000';
            } else {
                return '/colab/epr/projects/' + this.$route.params.projectId + '/content/' + this.documentId + '/preview?size=1000';
            }
        },
		openPdfPreview(clickable) {
            if (!clickable) {
                return false;
            } else {
                if(this.isShare) {
                    let documentUrl = this.baseUrl + '/colab/epr/public/share/' + this.$route.params.shareToken + '/pdf/';
                    window.open(documentUrl, 'PdfPreview', '"resizable=no, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no');
                } else {
                    this.$router.push(this.filePreviewRoute);
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .thumbnail-wrapper {
        overflow: hidden;
        cursor: pointer;
    }
    .default-cursor {
        cursor: default;
    }
</style>
